import React from "react";
import PhoneInput from "react-phone-number-input";
import type { Country, Value } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./phoneNumberInput.scss";
import CountrySelect from "./CountrySelect";

interface PhoneNumberInputProps {
  id?: string;
  value?: string;
  // Receives the E.164 number (e.g. "+19198123689"), or undefined when empty.
  onChange: (value?: string) => void;
  defaultCountry?: Country;
  disabled?: boolean;
  // Red border; the caller renders the message.
  invalid?: boolean;
}

/**
 * International phone input: a searchable country dropdown plus an as-you-type
 * formatted number field, powered by react-phone-number-input (libphonenumber-js).
 * The value is always stored/emitted in E.164 format.
 */
const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  id,
  value,
  onChange,
  defaultCountry = "US",
  disabled,
  invalid,
}) => (
  <PhoneInput
    className={invalid ? "phone-number-input is-invalid" : "phone-number-input"}
    numberInputProps={{
      id,
      className: "form-control",
      "aria-invalid": invalid || undefined,
    }}
    value={value as Value | undefined}
    onChange={(next?: Value) => onChange(next || undefined)}
    defaultCountry={defaultCountry}
    // Show an existing value in national format ("(919) 812-3689") rather than
    // the international default ("+1 919 812 3689"), so the calling code stays
    // owned by the country dropdown and the field reads as a local number.
    initialValueFormat="national"
    countrySelectComponent={CountrySelect}
    addInternationalOption={false}
    disabled={disabled}
  />
);

export default PhoneNumberInput;
